import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "../mapanalysis/chartTemplate";
import * as d3 from "d3";
import * as crossfilter from "crossfilter2/crossfilter";
import reductio from "reductio";

const prodDistChannel = (divRef, ndx) => {
  //select  the only required bins from the data
  function remove_empty_bins(source_group, remove_key) {
    return {
      all: function () {
        return source_group.all().filter(function (d) {
          return d.key !== remove_key;
        });
      },
    };
  }
  // fix for creating a grouped bar chart
  const BAR_PADDING = 0.1; // percentage the padding will take from the bar
  const RANGE_BAND_PADDING = 0.6; // padding between 'groups'
  const OUTER_RANGE_BAND_PADDING = 0.6; // padding from each side of the chart

  let sizing = (chart) => {
    chart.width(window.innerWidth).height(window.innerHeight).redraw();
  };

  let resizing = (chart) => (window.onresize = () => sizing(chart));

  let barPadding;
  let scaleSubChartBarWidth = (chart) => {
    let subs = chart.selectAll(".sub");

    if (typeof barPadding === "undefined") {
      // first draw only
      // to percentage
      barPadding = (BAR_PADDING / subs.size()) * 100;
      // each bar gets half the padding
      barPadding = barPadding / 2;
    }

    let startAt,
      endAt,
      subScale = d3.scaleLinear().domain([0, subs.size()]).range([0, 100]);

    subs.each(function (d, i) {
      startAt = subScale(i + 1) - subScale(1);
      endAt = subScale(i + 1);

      startAt += barPadding;
      endAt -= barPadding;
      d3.select(this)
        .selectAll("rect")
        .attr(
          "clip-path",
          `polygon(${startAt}% 0, ${endAt}% 0, ${endAt}% 100%, ${startAt}% 100%)`
        );
    });
  };

  const dist_types = ndx.dimension((d) => d.distribution_Types);
  // could be improved by arranging the data structure

  const dist_types_grp = dist_types
    .group()
    .reduceSum((d) => d.numberdist_channels);

  // could be improved by arranging the data structure

  const remove_null = remove_empty_bins(dist_types_grp, null);
  const Markets = remove_empty_bins(remove_null, "Markets");
  const Formal_Retailers = remove_empty_bins(Markets, "Formal Retailers");
  const distributions_channels = remove_empty_bins(
    Formal_Retailers,
    "Agro dealers"
  );
   
  let compositeChart = dc.compositeChart(divRef);
  let barChart1 = dc
    .barChart(compositeChart)
      .barPadding(0)
      .elasticY(true)
    .valueAccessor((d) => d.value)
    .title((d) => d.key + ": " + d.value.toFixed(2))
    .colors(["#478187"]);

  compositeChart
      .shareTitle(false)
      .width(300)
      .height(170)
     
      .dimension(dist_types)
      .group(distributions_channels)

    // .colors(d3.scaleOrdinal().domain([0, 1]).range(["#F9E0A4", "#80AED5"]))
      ._rangeBandPadding(RANGE_BAND_PADDING)
      ._outerRangeBandPadding(OUTER_RANGE_BAND_PADDING)
      .x(d3.scaleOrdinal())

      .y(d3.scaleLinear().domain([0, 100]))

      .xUnits(dc.units.ordinal)

      .compose([barChart1])
      // handle chart transition events
      .on("pretransition", (chart) => {
          scaleSubChartBarWidth(chart);
      })

      .on("filtered", (chart, filter) => {
          console.log(chart, filter);
      })

      .on("preRedraw", (chart) => {

          chart.rescale();

      })

      .on("preRender", (chart) => {

          chart.rescale();

      });

  // .render();
  compositeChart.yAxis().ticks(0);
  //   sizing(compositeChart);
  //   resizing(compositeChart);
  return compositeChart;
};

export const ProdDistChannel = (props) => (
  <ChartTemplate
    chartFunction={prodDistChannel}
    //  title="Crop Statistics"
  />
);
